/**
 * @generated SignedSource<<05b5183229622d1c00d311dcedf636a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectInvoicingTableSection_project$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingTable_project" | "InvoiceFilterButton_project">;
  readonly " $fragmentType": "ProjectInvoicingTableSection_project";
};
export type ProjectInvoicingTableSection_project$key = {
  readonly " $data"?: ProjectInvoicingTableSection_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingTableSection_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectInvoicingTableSection_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectInvoicingTable_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceFilterButton_project"
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "a211df0f496ae6149b0fa65ef4c267c5";

export default node;
